import React from 'react';
import moment from 'moment';
import * as FILTERS from 'services/consts';
import {
  REPORT_TYPE as REPORT_TYPE_SETTING,
  CHANNEL_TYPE_ID,
  FILTER_CONTACT_HISTORY_DIRECT,
  FILTER_CONTACT_HISTORY_INDIRECT2,
  FILTER_CONTACT_HISTORY_INDIRECT3,
  FILTER_CONTACT_HISTORY_INDIRECT4,
  FILTER_CONTACT_HISTORY_INDIRECT5,
  FILTER_CONTACT_HISTORY_INDIRECT6,
  FILTER_CONTACT_HISTORY_INDIRECT7,
  FILTER_CONTACT_HISTORY_INDIRECT8,
  FILTER_CONTACT_HISTORY_INDIRECT9,
  FILTER_CONTACT_HISTORY_INDIRECT10,
  FILTER_CONTACT_HISTORY_FIRST,
  PRIORITY_AXIS_EBIS,
} from 'domain/consts';
import { TAB_ALL, TAB_AD } from 'store/settings/constant';
import iconcsv from 'assets/images/icon-csv.png';
import iconspreadsheet from 'assets/images/icon-spreadsheet.png';
import iconadrepo from 'assets/images/icon-adrepo.png';
import {
  CATEGORY_ANALYZE,
  COMPARE_PERIOD,
  CV_ATTRIBUTE,
  DETAILS_ANALYSIS,
} from 'services/routes/constants';
import { USER_TYPE } from 'domain/fields';

export const REPORT_LIMIT = 0;
// update when user want to apply paginations
export const TABLE_ROWS_PER_PAGE = -1;

// contract type
export const CROSS_PAID = 2;
export const NO_CROSS_PAID = 0;

// report field
const REPORT_NAME = 'name';
const REPORT_TYPE = 'type';
const REPORT_OUTPUT = 'output';
const REPORT_STATUS = 'status';
const PERIOD_TIME = 'periodTime';
const COMPLETE_DATETIME = 'completeDatetime';
const MODIFY_USER = 'modifyUser';
const MODIFY_DATE = 'modifyDate';
export const EMAIL_INFO = 'emailInfo';
export const VIEW_HISTORY = 'view';

// Result google error
export const INVALID_CREDENTIALS = 1401;
export const NO_PERMISSION = 1403;
export const OVER_MILLION_CELLS = 1413;

// status report key
export const STATUS_TYPE_WAITING = 0;
export const STATUS_TYPE_RUNNING = 2;
export const STATUS_TYPE_SKIP = 4;
export const STATUS_TYPE_DELETE = 7;
export const STATUS_TYPE_COMPLETED = 9;

// status report display
export const STATUS_REPORT_ERROR = 'エラー';
export const STATUS_REPORT_PROCESSING = '処理中';
export const STATUS_REPORT_SUCCESS = '完了';
export const STATUS_REPORT_EMAIL_FAIL = '送信エラー';
export const STATUS_REPORT_EXPIRED = '期限切れ';
export const STATUS_REPORT_ERROR_INVALID_CREDENTIALS = '認証エラー';
export const STATUS_REPORT_ERROR_NO_PERMISSION = '権限エラー';
export const STATUS_REPORT_ERROR_OVER_MILLION_CELLS = '出力エラー';

// Result run batch
export const RESULT_TYPE_SUCCESS = 1;
export const RESULT_TYPE_ERROR_APP = 4;
export const RESULT_TYPE_ERROR_SYSTEM = 9;

// services store
export const SERVICE_STORE_REPORT_GOOGLE_DRIVE = 'google_drive';
export const SERVICE_STORE_REPORT_S3 = 's3';

// Report period
export const STATUS_PERIOD_MODE_NORMAL = 1;
export const STATUS_PERIOD_MODE_PERIODIC = 2;

export const WAIT_COST_OFF = 0;
export const WAIT_COST_ON = 1;

// Report period interval
export const STATUS_PERIOD_INTERVAL_DAY = 1;
export const STATUS_PERIOD_INTERVAL_WEEK = 2;
export const STATUS_PERIOD_INTERVAL_MONTH = 3;

export const PERIOD_INTERVAL_DAY = '昨日';
export const PERIOD_INTERVAL_WEEK = '先週';
export const PERIOD_INTERVAL_MONTH = '先月';

// report channels
export const CHANNEL_TYPE_ALL = TAB_ALL;
export const CHANNEL_TYPE_AD = TAB_AD;

export const PERIOD_MONDAY_KEY = 1;
export const PERIOD_SUNDAY_KEY = 7;

export const NO_EXIST_EMAIL = -1;

// report types for data export
export const REPORT_TYPE_CHANNEL = REPORT_TYPE_SETTING.CHANNEL;
export const REPORT_TYPE_ACCESS = REPORT_TYPE_SETTING.ACCESS;
export const REPORT_TYPE_CV_ATTRIBUTE = REPORT_TYPE_SETTING.CVATTR;
// report types for regular report
export const REPORT_TYPE_CATEGORY = REPORT_TYPE_SETTING.CATEGORY;
export const REPORT_TYPE_DETAIL = REPORT_TYPE_SETTING.DETAIL;
export const REPORT_TYPE_PERIOD = REPORT_TYPE_SETTING.PERIOD;
export const REPORT_TYPE_CONVERSION = REPORT_TYPE_SETTING.CONVERSION;
export const REPORT_TYPE_CATEGORY_PERIOD = REPORT_TYPE_SETTING.CATEGORY_PERIOD;
export const REPORT_TYPE_DETAIL_PERIOD = REPORT_TYPE_SETTING.DETAIL_PERIOD;
// report type for user have contract ad repo
export const REPORT_TYPE_AD_REPO = REPORT_TYPE_SETTING.ADREPO;

// Time axis
export const TIME_AXIS_DAILY = 'daily';
export const TIME_AXIS_MONTHLY = 'monthly';
export const TIME_AXIS_DAY_OF_WEEK = 'day_of_week';
export const TIME_AXIS_HOURLY = 'hourly';

// Group displayitem
export const DISPLAYITEM_GROUP_CHANNEL = 'channel';
export const DISPLAYITEM_GROUP_TIME = 'time';
export const DISPLAYITEM_GROUP_CONVERSION = 'conversion';
export const DISPLAYITEM_GROUP_SITE = 'site';
export const DISPLAYITEM_GROUP_CV_ATTRIBUTE = 'cv_attr';
export const DISPLAYITEM_FIXED = {
  [REPORT_TYPE_CV_ATTRIBUTE]: ['conversion_title'],
};

// service store
export const SERVICE_STORE_S3 = 's3';
export const SERVICE_STORE_GOOGLE_DRIVE = 'google_drive';
export const GOOGLE_DRIVE_DIR_PATH = '/adebis';

export const EMAIL_TITLE_MODE_DEFAULT = 1;
export const EMAIL_TITLE_MODE_CUSTOM = 2;

export const MIN_DIMENSION = 1;
export const MAX_DIMENSION = 10;

export const MIN_METRIC = 1;
export const MAX_METRIC = 15;

export const MAX_LENGTH_REPORT_NAME = 30;
export const MAX_LENGTH_EMAIL_TITLE = 1000;
export const MAX_LENGTH_GOOGLE_DIR_PATH = 10000;
export const MAX_LENGTH_CUSTOM_FILENAME = 50;

export const WEEKDAY_MONDAY = 1;

export const WEEK_DAYS = {
  1: '月',
  2: '火',
  3: '水',
  4: '木',
  5: '金',
  6: '土',
  7: '日',
};

export const PERIOD_INTERVALS = {
  [STATUS_PERIOD_INTERVAL_DAY]: '毎日',
  [STATUS_PERIOD_INTERVAL_WEEK]: '毎週',
  [STATUS_PERIOD_INTERVAL_MONTH]: '毎月',
};

// --- Periodic output (regular report): frequency × target period encoding ---

/** UI frequency keys used when encoding/decoding period_interval */
export const PERIOD_FREQUENCY = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
};

/** UI 対象期間 keys */
export const TARGET_PERIOD = {
  YESTERDAY: 'yesterday',
  THIS_WEEK_TO_YESTERDAY: 'this_week_to_yesterday',
  LAST_WEEK_MON_SUN: 'last_week_mon_sun',
  LAST_WEEK_MON_FRI: 'last_week_mon_fri',
  THIS_MONTH_TO_YESTERDAY: 'this_month_to_yesterday',
  LAST_MONTH: 'last_month',
  LAST_7_DAYS_TO_YESTERDAY: 'last_7_days_to_yesterday',
  LAST_14_DAYS_TO_YESTERDAY: 'last_14_days_to_yesterday',
  LAST_30_DAYS_TO_YESTERDAY: 'last_30_days_to_yesterday',
};

export const DEFAULT_TARGET_PERIOD = TARGET_PERIOD.YESTERDAY;

export const TARGET_PERIOD_LABELS = {
  [TARGET_PERIOD.YESTERDAY]: '昨日',
  [TARGET_PERIOD.THIS_WEEK_TO_YESTERDAY]: '今週（月～昨日）',
  [TARGET_PERIOD.LAST_WEEK_MON_SUN]: '前週（月～日）',
  [TARGET_PERIOD.LAST_WEEK_MON_FRI]: '前週（月～金）',
  [TARGET_PERIOD.THIS_MONTH_TO_YESTERDAY]: '今月（昨日まで）',
  [TARGET_PERIOD.LAST_MONTH]: '前月',
  [TARGET_PERIOD.LAST_7_DAYS_TO_YESTERDAY]: '過去7日（昨日まで）',
  [TARGET_PERIOD.LAST_14_DAYS_TO_YESTERDAY]: '過去14日（昨日まで）',
  [TARGET_PERIOD.LAST_30_DAYS_TO_YESTERDAY]: '過去30日（昨日まで）',
};

/** period_interval int → { frequency, targetPeriod } lookup table */
export const PERIOD_INTERVAL_CODE_TABLE = {
  1: {
    frequency: PERIOD_FREQUENCY.DAILY,
    targetPeriod: TARGET_PERIOD.YESTERDAY,
  },
  11: {
    frequency: PERIOD_FREQUENCY.DAILY,
    targetPeriod: TARGET_PERIOD.THIS_WEEK_TO_YESTERDAY,
  },
  12: {
    frequency: PERIOD_FREQUENCY.DAILY,
    targetPeriod: TARGET_PERIOD.THIS_MONTH_TO_YESTERDAY,
  },
  13: {
    frequency: PERIOD_FREQUENCY.DAILY,
    targetPeriod: TARGET_PERIOD.LAST_7_DAYS_TO_YESTERDAY,
  },
  14: {
    frequency: PERIOD_FREQUENCY.DAILY,
    targetPeriod: TARGET_PERIOD.LAST_14_DAYS_TO_YESTERDAY,
  },
  15: {
    frequency: PERIOD_FREQUENCY.DAILY,
    targetPeriod: TARGET_PERIOD.LAST_30_DAYS_TO_YESTERDAY,
  },
  21: {
    frequency: PERIOD_FREQUENCY.WEEKLY,
    targetPeriod: TARGET_PERIOD.YESTERDAY,
  },
  22: {
    frequency: PERIOD_FREQUENCY.WEEKLY,
    targetPeriod: TARGET_PERIOD.THIS_WEEK_TO_YESTERDAY,
  },
  23: {
    frequency: PERIOD_FREQUENCY.WEEKLY,
    targetPeriod: TARGET_PERIOD.LAST_WEEK_MON_SUN,
  },
  24: {
    frequency: PERIOD_FREQUENCY.WEEKLY,
    targetPeriod: TARGET_PERIOD.LAST_WEEK_MON_FRI,
  },
  25: {
    frequency: PERIOD_FREQUENCY.WEEKLY,
    targetPeriod: TARGET_PERIOD.THIS_MONTH_TO_YESTERDAY,
  },
  2: {
    frequency: PERIOD_FREQUENCY.WEEKLY,
    targetPeriod: TARGET_PERIOD.LAST_7_DAYS_TO_YESTERDAY,
  },
  26: {
    frequency: PERIOD_FREQUENCY.WEEKLY,
    targetPeriod: TARGET_PERIOD.LAST_14_DAYS_TO_YESTERDAY,
  },
  27: {
    frequency: PERIOD_FREQUENCY.WEEKLY,
    targetPeriod: TARGET_PERIOD.LAST_30_DAYS_TO_YESTERDAY,
  },
  31: {
    frequency: PERIOD_FREQUENCY.MONTHLY,
    targetPeriod: TARGET_PERIOD.YESTERDAY,
  },
  32: {
    frequency: PERIOD_FREQUENCY.MONTHLY,
    targetPeriod: TARGET_PERIOD.THIS_WEEK_TO_YESTERDAY,
  },
  33: {
    frequency: PERIOD_FREQUENCY.MONTHLY,
    targetPeriod: TARGET_PERIOD.LAST_WEEK_MON_SUN,
  },
  34: {
    frequency: PERIOD_FREQUENCY.MONTHLY,
    targetPeriod: TARGET_PERIOD.LAST_WEEK_MON_FRI,
  },
  35: {
    frequency: PERIOD_FREQUENCY.MONTHLY,
    targetPeriod: TARGET_PERIOD.THIS_MONTH_TO_YESTERDAY,
  },
  3: {
    frequency: PERIOD_FREQUENCY.MONTHLY,
    targetPeriod: TARGET_PERIOD.LAST_MONTH,
  },
  36: {
    frequency: PERIOD_FREQUENCY.MONTHLY,
    targetPeriod: TARGET_PERIOD.LAST_7_DAYS_TO_YESTERDAY,
  },
  37: {
    frequency: PERIOD_FREQUENCY.MONTHLY,
    targetPeriod: TARGET_PERIOD.LAST_14_DAYS_TO_YESTERDAY,
  },
  38: {
    frequency: PERIOD_FREQUENCY.MONTHLY,
    targetPeriod: TARGET_PERIOD.LAST_30_DAYS_TO_YESTERDAY,
  },
};

/** 対象期間 options ordered by frequency */
export const TARGET_PERIODS_BY_FREQUENCY = {
  [PERIOD_FREQUENCY.DAILY]: [
    TARGET_PERIOD.YESTERDAY,
    TARGET_PERIOD.THIS_WEEK_TO_YESTERDAY,
    TARGET_PERIOD.THIS_MONTH_TO_YESTERDAY,
    TARGET_PERIOD.LAST_7_DAYS_TO_YESTERDAY,
    TARGET_PERIOD.LAST_14_DAYS_TO_YESTERDAY,
    TARGET_PERIOD.LAST_30_DAYS_TO_YESTERDAY,
  ],
  [PERIOD_FREQUENCY.WEEKLY]: [
    TARGET_PERIOD.YESTERDAY,
    TARGET_PERIOD.THIS_WEEK_TO_YESTERDAY,
    TARGET_PERIOD.LAST_WEEK_MON_SUN,
    TARGET_PERIOD.LAST_WEEK_MON_FRI,
    TARGET_PERIOD.THIS_MONTH_TO_YESTERDAY,
    TARGET_PERIOD.LAST_7_DAYS_TO_YESTERDAY,
    TARGET_PERIOD.LAST_14_DAYS_TO_YESTERDAY,
    TARGET_PERIOD.LAST_30_DAYS_TO_YESTERDAY,
  ],
  [PERIOD_FREQUENCY.MONTHLY]: [
    TARGET_PERIOD.YESTERDAY,
    TARGET_PERIOD.THIS_WEEK_TO_YESTERDAY,
    TARGET_PERIOD.LAST_WEEK_MON_SUN,
    TARGET_PERIOD.LAST_WEEK_MON_FRI,
    TARGET_PERIOD.THIS_MONTH_TO_YESTERDAY,
    TARGET_PERIOD.LAST_MONTH,
    TARGET_PERIOD.LAST_7_DAYS_TO_YESTERDAY,
    TARGET_PERIOD.LAST_14_DAYS_TO_YESTERDAY,
    TARGET_PERIOD.LAST_30_DAYS_TO_YESTERDAY,
  ],
};

/** Labels for regular-report 出力設定 block */
export const OUTPUT_SETTING_LABELS = {
  blockTitle: '出力設定',
  periodCycle: '出力サイクル',
  formatSettings: 'フォーマット設定',
  onceOnly: '1回のみ',
  periodic: '定期',
  targetPeriod: '対象期間',
  frequency: '頻度',
};

/** 1回のみ preset list (Figma order) */
export const ONCE_ONLY_TARGET_PERIOD_PRESETS = [
  { key: 'today', label: '今日' },
  { key: 'yesterday', label: '昨日' },
  { key: 'this_week_to_yesterday', label: '今週（月～昨日）' },
  { key: 'last_week_mon_sun', label: '前週（月～日）' },
  { key: 'last_week_mon_fri', label: '前週（月～金）' },
  { key: 'this_month_to_yesterday', label: '今月（昨日まで）' },
  { key: 'last_month', label: '前月' },
  { key: 'last_7_days_to_yesterday', label: '過去7日（昨日まで）' },
  { key: 'last_14_days_to_yesterday', label: '過去14日（昨日まで）' },
  { key: 'last_30_days_to_yesterday', label: '過去30日（昨日まで）' },
];

/**
 * Clamp once-only start/end to min/max calendar bounds only.
 * Spans longer than 3 months are allowed in the picker; save-time
 * validation rejects them (regular message: 対象期間は、3か月以内で設定してください。).
 */
export const clampOnceOnlyPeriodRange = (
  rawStart,
  rawEnd,
  { minDate, maxDate } = {}
) => {
  let start = rawStart?.clone?.() ?? (rawStart ? moment(rawStart) : null);
  let end = rawEnd?.clone?.() ?? (rawEnd ? moment(rawEnd) : null);
  if (!start || !start.isValid()) return { start: null, end: null };

  if (minDate && start.isBefore(minDate, 'day')) start = minDate.clone();
  if (maxDate && start.isAfter(maxDate, 'day')) start = maxDate.clone();
  if (!end || !end.isValid()) end = start.clone();
  if (maxDate && end.isAfter(maxDate, 'day')) end = maxDate.clone();
  if (end.isBefore(start, 'day')) end = start.clone();

  return { start, end };
};

/** Frequency radio options (毎日 / 毎週 / 毎月) */
export const FREQUENCY_RADIO_OPTIONS = [
  { value: PERIOD_FREQUENCY.DAILY, label: '毎日' },
  { value: PERIOD_FREQUENCY.WEEKLY, label: '毎週' },
  { value: PERIOD_FREQUENCY.MONTHLY, label: '毎月' },
];

/** Weekly output weekday label / default */
export const WEEKDAY_OUTPUT_LABEL = '曜日に出力';
export const DEFAULT_WEEKDAY = WEEKDAY_MONDAY;

/**
 * Monthly output day for regular-report only (101–127, 999 = 末日).
 * Offset 100 keeps monthly values distinct from weekly weekday 1–7.
 * UI still shows calendar day 1–27 / 末日.
 */
export const MONTHLY_RECEIVE_DAY_OFFSET = 100;
export const END_OF_MONTH_RECEIVE_DAY = 999;
export const DEFAULT_MONTHLY_OUTPUT_DAY = MONTHLY_RECEIVE_DAY_OFFSET + 1;
export const MONTHLY_OUTPUT_DAY_LABEL = '日に出力';
export const MONTHLY_OUTPUT_DAY_OPTIONS = [
  ...Array.from(
    { length: 27 },
    (_, i) => i + 1 + MONTHLY_RECEIVE_DAY_OFFSET
  ),
  END_OF_MONTH_RECEIVE_DAY,
];

/** Validation messages on regular-report path */
export const REGULAR_PERIOD_ERROR_MESSAGES = {
  // Keep legacy copy for accept / required — do not rename to 対象期間
  ACCEPT_VALUE: '集計期間を正しく設定してください。',
  START_REQUIRED: '集計期間(開始日)を設定してください。',
  END_REQUIRED: '集計期間(終了日)を設定してください。',
  // 1回のみ span over 3 months at 登録
  MAX_SPAN: '対象期間は、3か月以内で設定してください。',
};

// Helpers for 定期出力 (kept here to avoid new modules / circular imports with services)

const PERIOD_INTERVAL_ENCODE_LOOKUP = Object.entries(
  PERIOD_INTERVAL_CODE_TABLE
).reduce((acc, [code, { frequency, targetPeriod }]) => {
  acc[`${frequency}:${targetPeriod}`] = Number(code);
  return acc;
}, {});

export const encodePeriodInterval = (frequency, targetPeriod) => {
  const code = PERIOD_INTERVAL_ENCODE_LOOKUP[`${frequency}:${targetPeriod}`];
  return code === undefined ? null : code;
};

export const decodePeriodInterval = (code) => {
  if (code === null || code === undefined) return null;
  const entry = PERIOD_INTERVAL_CODE_TABLE[Number(code)];
  return entry ? { ...entry } : null;
};

export const toLegacyPeriodInterval = (frequency) => {
  if (frequency === PERIOD_FREQUENCY.DAILY) return 1;
  if (frequency === PERIOD_FREQUENCY.WEEKLY) return 2;
  if (frequency === PERIOD_FREQUENCY.MONTHLY) return 3;
  return null;
};

export const getTargetPeriodsForFrequency = (frequency) => {
  return TARGET_PERIODS_BY_FREQUENCY[frequency]
    ? [...TARGET_PERIODS_BY_FREQUENCY[frequency]]
    : [];
};

export const isValidPeriodReceiveDay = (frequency, day) => {
  // 毎日: no weekday / output day — must be empty
  if (frequency === PERIOD_FREQUENCY.DAILY) {
    return day === null || day === undefined || day === '';
  }
  if (frequency === PERIOD_FREQUENCY.WEEKLY) {
    return Number.isInteger(day) && day >= 1 && day <= 7;
  }
  if (frequency === PERIOD_FREQUENCY.MONTHLY) {
    if (day === END_OF_MONTH_RECEIVE_DAY) return true;
    return (
      Number.isInteger(day) &&
      day >= MONTHLY_RECEIVE_DAY_OFFSET + 1 &&
      day <= MONTHLY_RECEIVE_DAY_OFFSET + 27
    );
  }
  return false;
};

export const isValidPeriodIntervalCode = (code) => {
  return Object.prototype.hasOwnProperty.call(
    PERIOD_INTERVAL_CODE_TABLE,
    Number(code)
  );
};

export const getPeriodModeControlState = (periodMode) => {
  const isOnceOnly = periodMode === STATUS_PERIOD_MODE_NORMAL;
  return {
    onceOnlyTargetPeriodEnabled: isOnceOnly,
    frequencyEnabled: !isOnceOnly,
    weekdayOrOutputDayEnabled: !isOnceOnly,
    periodicTargetPeriodEnabled: !isOnceOnly,
  };
};

const ONCE_ONLY_PRESET_DISPLAY_DATE = 'YYYY/MM/DD';

export const resolveOnceOnlyPresetRange = (presetKey, options = {}) => {
  const today = moment(options.today || undefined).startOf('day');
  const yesterday = today.clone().subtract(1, 'day');

  let start;
  let end;

  switch (presetKey) {
    case 'today':
      start = today.clone();
      end = today.clone();
      break;
    case 'yesterday':
      start = yesterday.clone();
      end = yesterday.clone();
      break;
    case 'this_week_to_yesterday': {
      // Mon: Mon～yesterday is empty → use previous week Mon～Sun
      start = today.clone().startOf('isoWeek');
      end = yesterday;
      if (end.isBefore(start, 'day')) {
        start = today.clone().startOf('isoWeek').subtract(1, 'week');
        end = start.clone().add(6, 'days');
      }
      break;
    }
    case 'last_week_mon_sun': {
      const lastWeekMonday = today
        .clone()
        .startOf('isoWeek')
        .subtract(1, 'week');
      start = lastWeekMonday;
      end = lastWeekMonday.clone().add(6, 'days');
      break;
    }
    case 'last_week_mon_fri': {
      const lastWeekMonday = today
        .clone()
        .startOf('isoWeek')
        .subtract(1, 'week');
      start = lastWeekMonday;
      end = lastWeekMonday.clone().add(4, 'days');
      break;
    }
    case 'this_month_to_yesterday': {
      // Day 1: month-start～yesterday is empty → use previous calendar month
      start = today.clone().startOf('month');
      end = yesterday;
      if (end.isBefore(start, 'day')) {
        start = today.clone().subtract(1, 'month').startOf('month');
        end = today.clone().subtract(1, 'month').endOf('month');
      }
      break;
    }
    case 'last_month':
      start = today.clone().subtract(1, 'month').startOf('month');
      end = today.clone().subtract(1, 'month').endOf('month');
      break;
    case 'last_7_days_to_yesterday':
      end = yesterday;
      start = yesterday.clone().subtract(6, 'days');
      break;
    case 'last_14_days_to_yesterday':
      end = yesterday;
      start = yesterday.clone().subtract(13, 'days');
      break;
    case 'last_30_days_to_yesterday':
      end = yesterday;
      start = yesterday.clone().subtract(29, 'days');
      break;
    default:
      return null;
  }

  if (end.isBefore(start, 'day')) {
    return null;
  }

  return {
    start: start.format(ONCE_ONLY_PRESET_DISPLAY_DATE),
    end: end.format(ONCE_ONLY_PRESET_DISPLAY_DATE),
  };
};

export const resolveTargetPeriodOnFrequencyChange = (
  newFrequency,
  currentTargetPeriod
) => {
  const allowed = getTargetPeriodsForFrequency(newFrequency);
  if (allowed.includes(currentTargetPeriod)) {
    return currentTargetPeriod;
  }
  return DEFAULT_TARGET_PERIOD;
};

export const formatMonthlyOutputDayLabel = (day) => {
  if (day === END_OF_MONTH_RECEIVE_DAY) return '末日';
  if (
    Number.isInteger(day) &&
    day >= MONTHLY_RECEIVE_DAY_OFFSET + 1 &&
    day <= MONTHLY_RECEIVE_DAY_OFFSET + 27
  ) {
    return String(day - MONTHLY_RECEIVE_DAY_OFFSET);
  }
  // null / undefined / invalid → show default 1日 (same as weekly WEEK_DAYS fallback)
  return String(DEFAULT_MONTHLY_OUTPUT_DAY - MONTHLY_RECEIVE_DAY_OFFSET);
};

export const normalizeReceiveDayOnFrequencyChange = (
  newFrequency,
  currentReceiveDay
) => {
  if (newFrequency === PERIOD_FREQUENCY.DAILY) {
    return '';
  }
  if (isValidPeriodReceiveDay(newFrequency, currentReceiveDay)) {
    return currentReceiveDay;
  }
  if (newFrequency === PERIOD_FREQUENCY.WEEKLY) {
    return DEFAULT_WEEKDAY;
  }
  if (newFrequency === PERIOD_FREQUENCY.MONTHLY) {
    return DEFAULT_MONTHLY_OUTPUT_DAY;
  }
  return currentReceiveDay;
};

/**
 * Load regular-report detail: coerce API receive_day and fill defaults.
 * Legacy monthly often returned null (or leftover 1…7) — map to 101…127 / 999 domain.
 */
export const normalizeReceiveDayOnLoad = (frequency, receiveDay) => {
  let day = receiveDay;
  if (day !== null && day !== undefined && day !== '') {
    const num = Number(day);
    if (!Number.isNaN(num)) {
      day = num;
    }
  }
  return normalizeReceiveDayOnFrequencyChange(frequency, day);
};

export const formatPeriodicPeriodTimeLabel = (periodIntervalCode) => {
  const decoded = decodePeriodInterval(periodIntervalCode);
  if (!decoded) return null;
  return TARGET_PERIOD_LABELS[decoded.targetPeriod] || null;
};

/**
 * When switching regular → custom: keep 頻度/曜日 visible, but store only
 * legacy period_interval 1|2|3. Custom validation/API do not accept composite
 * codes or receive_day outside 1..7.
 */
export const normalizePeriodFieldsForCustomReport = ({
  periodInterval,
  receiveDay,
}) => {
  const intervalNum = Number(periodInterval);
  const isLegacy = [
    STATUS_PERIOD_INTERVAL_DAY,
    STATUS_PERIOD_INTERVAL_WEEK,
    STATUS_PERIOD_INTERVAL_MONTH,
  ].includes(intervalNum);

  let nextInterval = intervalNum;
  if (!isLegacy) {
    const decoded = decodePeriodInterval(intervalNum);
    nextInterval =
      toLegacyPeriodInterval(decoded?.frequency) ?? STATUS_PERIOD_INTERVAL_DAY;
  }

  const dayNum = Number(receiveDay);
  const nextReceiveDay =
    Number.isInteger(dayNum) && dayNum >= 1 && dayNum <= 7
      ? dayNum
      : DEFAULT_WEEKDAY;

  return {
    period_interval: nextInterval,
    period_receive_report_day: nextReceiveDay,
  };
};

/**
 * When switching custom → regular: legacy period_interval 1|2|3 is frequency
 * only. Map to the same frequency with default 対象期間 (昨日), and normalize
 * receive_day for that frequency. Composite codes are left unchanged.
 * Does not touch period_start/period_end — over-3-month ranges stay as-is
 * and are rejected at 登録 for regular only.
 */
export const normalizePeriodFieldsForRegularReport = ({
  periodInterval,
  receiveDay,
}) => {
  const intervalNum = Number(periodInterval);
  const isLegacy = [
    STATUS_PERIOD_INTERVAL_DAY,
    STATUS_PERIOD_INTERVAL_WEEK,
    STATUS_PERIOD_INTERVAL_MONTH,
  ].includes(intervalNum);

  if (!isLegacy) {
    const decoded = decodePeriodInterval(intervalNum);
    return {
      period_interval: intervalNum,
      period_receive_report_day:
        decoded?.frequency === PERIOD_FREQUENCY.DAILY ? '' : Number(receiveDay),
    };
  }

  let frequency = PERIOD_FREQUENCY.MONTHLY;
  if (intervalNum === STATUS_PERIOD_INTERVAL_DAY) {
    frequency = PERIOD_FREQUENCY.DAILY;
  } else if (intervalNum === STATUS_PERIOD_INTERVAL_WEEK) {
    frequency = PERIOD_FREQUENCY.WEEKLY;
  }

  const nextInterval = encodePeriodInterval(frequency, DEFAULT_TARGET_PERIOD);
  const nextReceiveDay = normalizeReceiveDayOnFrequencyChange(
    frequency,
    Number(receiveDay)
  );

  return {
    period_interval: nextInterval ?? STATUS_PERIOD_INTERVAL_DAY,
    period_receive_report_day: nextReceiveDay,
  };
};

export const SERVICE_STORES = {
  [SERVICE_STORE_S3]: {
    label: 'CSV',
    value: 's3',
    icon: iconcsv,
    disabled: false,
  },
  [SERVICE_STORE_GOOGLE_DRIVE]: {
    label: 'Googleスプレッドシート',
    value: 'google_drive',
    icon: iconspreadsheet,
    disabled: false,
  },
  [REPORT_TYPE_AD_REPO]: {
    label: 'アドレポ連携用',
    value: 'neo',
    icon: iconadrepo,
    disabled: false,
  },
};

// label group displayitem
export const DIMENSION_GROUP_LABEL = {
  [DISPLAYITEM_GROUP_CHANNEL]: 'チャネル軸',
  [DISPLAYITEM_GROUP_TIME]: '時間軸',
  [DISPLAYITEM_GROUP_CONVERSION]: 'コンバージョン軸',
  [DISPLAYITEM_GROUP_SITE]: 'サイト軸',
};

export const METRIC_GROUP_LABEL = {
  [DISPLAYITEM_GROUP_CHANNEL]: 'チャネル別流入関連',
  [DISPLAYITEM_GROUP_CONVERSION]: 'コンバージョン関連',
  [DISPLAYITEM_GROUP_SITE]: 'サイト内アクセス関連',
};

// labels or report type
export const REPORT_TYPES = {
  [REPORT_TYPE_CHANNEL]: 'チャネル',
  [REPORT_TYPE_ACCESS]: 'アクセス解析',
  [REPORT_TYPE_CV_ATTRIBUTE]: 'コンバージョン属性',
  [REPORT_TYPE_CATEGORY]: 'カテゴリ分析レポート',
  [REPORT_TYPE_DETAIL]: '詳細分析レポート',
  [REPORT_TYPE_PERIOD]: '期間分析レポート',
  [REPORT_TYPE_CONVERSION]: 'コンバージョン属性レポート', // will be change after Q&A
  [REPORT_TYPE_CATEGORY_PERIOD]: 'カテゴリ分析×期間分析レポート',
  [REPORT_TYPE_DETAIL_PERIOD]: '詳細分析×期間分析レポート',
  [REPORT_TYPE_AD_REPO]: 'アドレポ連携',
};

export const REPORT_TYPES_REGULAR_REPORT = [
  REPORT_TYPE_CATEGORY,
  REPORT_TYPE_DETAIL,
  REPORT_TYPE_PERIOD,
  REPORT_TYPE_CONVERSION,
  REPORT_TYPE_CATEGORY_PERIOD,
  REPORT_TYPE_DETAIL_PERIOD,
];

export const REPORT_TYPES_DATA_EXPORT = [
  REPORT_TYPE_CHANNEL,
  REPORT_TYPE_CV_ATTRIBUTE,
  REPORT_TYPE_ACCESS,
];

export const PAGE_ID_BY_REPORT_TYPE = {
  [REPORT_TYPE_CATEGORY]: CATEGORY_ANALYZE,
  [REPORT_TYPE_CATEGORY_PERIOD]: CATEGORY_ANALYZE,
  [REPORT_TYPE_DETAIL]: DETAILS_ANALYSIS,
  [REPORT_TYPE_DETAIL_PERIOD]: DETAILS_ANALYSIS,
  [REPORT_TYPE_PERIOD]: COMPARE_PERIOD,
  [REPORT_TYPE_CONVERSION]: CV_ATTRIBUTE,
};

export const ERRORS_SHEET = {
  [INVALID_CREDENTIALS]:
    'Googleアカウントの認証が無効になっている可能性があります。[編集]＞【データエクスポート設定】にてGoogleアカウントの認証を行ってください。',
  [NO_PERMISSION]:
    '設定されたGoogleアカウントの権限に「編集権限」がないため、スプレットシートを作成できませんでした。[編集]＞【データエクスポート設定】にて「編集権限」のあるGoogleアカウントを設定してください。',
  [OVER_MILLION_CELLS]:
    '出力データがGoogleスプレッドシートのセル上限(1000万セル)を超過しました。レポートの出力条件を変更してください。',
};

export const MSG_NO_PERMISSION_SETTING =
  'レポート作成に必要な契約または機能権限がありません。';

export const HEADER_LIST_REPORT = [
  {
    field: 'rowId',
    name: '',
    type: 'checkbox',
    isFreeze: true,
    isEdit: true,
  },
  {
    field: REPORT_NAME,
    name: 'レポート名',
    isFreeze: true,
  },
  {
    field: REPORT_TYPE,
    name: 'レポートタイプ',
    isFreeze: true,
  },
  {
    field: REPORT_OUTPUT,
    name: '出力先',
    minWidth: '147px',
    isContentCenter: true,
  },
  {
    field: REPORT_STATUS,
    name: 'ステータス',
    isContentCenter: true,
  },
  {
    field: PERIOD_TIME,
    name: '対象期間',
    minWidth: '115px',
    isContentCenter: true,
  },
  {
    field: MODIFY_DATE,
    name: '最終設定更新日時',
    minWidth: '140px',
    isContentCenter: true,
  },
  {
    field: MODIFY_USER,
    name: '更新ユーザーID',
    minWidth: '122px',
    isContentCenter: true,
  },
  {
    field: COMPLETE_DATETIME,
    name: '最終レポート作成日時',
    minWidth: '164px',
    isContentCenter: true,
  },
  {
    field: VIEW_HISTORY,
    name: 'レポート作成履歴',
    isContentCenter: true,
    isViewDetail: true,
    variant: 'btn-link',
  },
];

export const HEADER_VIEW_HISTORY = [
  {
    field: REPORT_NAME,
    name: '生成済レポート名',
    width: '151px',
  },
  {
    field: PERIOD_TIME,
    name: '集計期間',
    width: '115px',
  },
  {
    field: COMPLETE_DATETIME,
    name: 'レポート作成完了時間',
    width: '165px',
  },
  {
    field: EMAIL_INFO,
    name: '通知先',
    width: '212px',
  },
  {
    field: REPORT_STATUS,
    name: 'ステータス',
    width: '100px',
  },
];

export const CONTACT_HISTORIES = [
  { name: 'direct', text: '直接効果' },
  { name: 'indirect_2', text: '間接効果2' },
  { name: 'indirect_3', text: '間接効果3' },
  { name: 'indirect_4', text: '間接効果4' },
  { name: 'indirect_5', text: '間接効果5' },
  { name: 'indirect_6', text: '間接効果6' },
  { name: 'indirect_7', text: '間接効果7' },
  { name: 'indirect_8', text: '間接効果8' },
  { name: 'indirect_9', text: '間接効果9' },
  { name: 'indirect_10', text: '間接効果10' },
  { name: 'first_contract', text: '初回接触' },
];

// report field for setting
export const REPORT_FIELDS = {
  REPORT_NAME: 'name',
  REPORT_TYPE: 'type',
  REPORT_CHANNEL: 'channel',
  SERVICE_STORE: 'service_store',
  DISPLAY_ITEMS: 'display_items',
  DIMENSIONS: 'dimensions',
  METRICS: 'metrics',
  CONTACT_HISTORY: 'contact_history',
  PERIOD: 'period',
  PERIOD_MODE: 'period_mode',
  PERIOD_START: 'period_start',
  PERIOD_END: 'period_end',
  PERIOD_INTERVAL: 'period_interval',
  PERIOD_RECEIVE_REPORT_DAY: 'period_receive_report_day',
  CUSTOM_FILENAME: 'custom_filename',
  WAIT_COST: 'wait_cost',
  DISPLAY: 'display',
  DISPLAY_TOTAL: 'display_total',
  DISPLAY_ROW_ZERO: 'display_row_zero',
  DISPLAY_HEADER: 'display_header',
  DISPLAY_CLICK_LP_URL: 'display_click_lp_url',
  SHARED_USERS: 'shared_users',
  EMAIL: 'email',
  SEND_EMAIL_MODE: 'send_email_mode',
  EMAIL_TITLE_MODE: 'email_title_mode',
  EMAIL_TITLE: 'email_title',
  QUICK_SEARCH: 'quick_search',
  FILTERS: 'filters',
  GOOGLE_ACCOUNT: 'google_account',
  GOOGLE_DIR_PATH: 'google_dir_path',
  GOOGLE_SAVE_MODE: 'google_save_mode',
  RESULT_ERROR_CODE: 'result_error_code',
  SUMMARY_MODE: 'summary_mode',
  AXIS: 'axis',
  SORT: 'sort',
};

export const DEFAULT_DETAIL_REPORT = {
  [REPORT_FIELDS.SERVICE_STORE]: SERVICE_STORE_S3,
  [REPORT_FIELDS.REPORT_TYPE]: REPORT_TYPE_CATEGORY,
  [REPORT_FIELDS.REPORT_CHANNEL]: CHANNEL_TYPE_AD,
  [REPORT_FIELDS.REPORT_NAME]: REPORT_TYPES[REPORT_TYPE_CATEGORY].label,
  [REPORT_FIELDS.DIMENSIONS]: [],
  [REPORT_FIELDS.METRICS]: [],
  [REPORT_FIELDS.CONTACT_HISTORY]: CONTACT_HISTORIES.map((item) => item.name),
  [REPORT_FIELDS.PERIOD_MODE]: STATUS_PERIOD_MODE_NORMAL,
  [REPORT_FIELDS.PERIOD_START]: '',
  [REPORT_FIELDS.PERIOD_END]: '',
  [REPORT_FIELDS.PERIOD_INTERVAL]: STATUS_PERIOD_INTERVAL_DAY,
  [REPORT_FIELDS.PERIOD_RECEIVE_REPORT_DAY]: WEEKDAY_MONDAY,
  [REPORT_FIELDS.CUSTOM_FILENAME]: '',
  [REPORT_FIELDS.WAIT_COST]: WAIT_COST_ON,
  [REPORT_FIELDS.DISPLAY_TOTAL]: false,
  [REPORT_FIELDS.DISPLAY_ROW_ZERO]: false,
  [REPORT_FIELDS.DISPLAY_HEADER]: false,
  [REPORT_FIELDS.DISPLAY_CLICK_LP_URL]: false,
  [REPORT_FIELDS.GOOGLE_ACCOUNT]: null,
  [REPORT_FIELDS.SHARED_USERS]: [],
  [REPORT_FIELDS.SEND_EMAIL_MODE]: true,
  [REPORT_FIELDS.EMAIL_TITLE_MODE]: EMAIL_TITLE_MODE_DEFAULT,
  [REPORT_FIELDS.EMAIL_TITLE]: '',
  [REPORT_FIELDS.GOOGLE_DIR_PATH]: GOOGLE_DRIVE_DIR_PATH,
  [REPORT_FIELDS.GOOGLE_SAVE_MODE]: 'new',
  [REPORT_FIELDS.QUICK_SEARCH]: {},
  [REPORT_FIELDS.FILTERS]: {},
  [REPORT_FIELDS.DISPLAY_ITEMS]: {},
  [REPORT_FIELDS.SUMMARY_MODE]: TIME_AXIS_DAILY,
  [REPORT_FIELDS.AXIS]: PRIORITY_AXIS_EBIS,
  [REPORT_FIELDS.SORT]: {},
};

const ignoreRegularReportFields = [
  REPORT_FIELDS.REPORT_CHANNEL,
  REPORT_FIELDS.FILTERS,
  REPORT_FIELDS.AXIS,
  REPORT_FIELDS.SORT,
  REPORT_FIELDS.DISPLAY_ITEMS,
  REPORT_FIELDS.SUMMARY_MODE,
  REPORT_FIELDS.CUSTOM_FILENAME,
];

const ignoreDataExportFields = [
  REPORT_FIELDS.DIMENSIONS,
  REPORT_FIELDS.METRICS,
  REPORT_FIELDS.QUICK_SEARCH,
  REPORT_FIELDS.CONTACT_HISTORY,
  REPORT_FIELDS.DISPLAY_CLICK_LP_URL,
];

export const REPORT_TYPES_FOR_SETTING = {
  [REPORT_TYPE_CHANNEL]: {
    label: 'チャネルレポート',
    value: REPORT_TYPE_CHANNEL,
    ignoreFields: [...ignoreRegularReportFields, REPORT_FIELDS.CONTACT_HISTORY],
  },
  [REPORT_TYPE_CV_ATTRIBUTE]: {
    label: 'コンバージョン属性レポート',
    value: REPORT_TYPE_CV_ATTRIBUTE,
    ignoreFields: [
      ...ignoreRegularReportFields,
      REPORT_FIELDS.METRICS,
      REPORT_FIELDS.WAIT_COST,
      REPORT_FIELDS.DISPLAY_TOTAL,
      REPORT_FIELDS.DISPLAY_ROW_ZERO,
    ],
  },
  [REPORT_TYPE_ACCESS]: {
    label: 'アクセス解析レポート',
    value: REPORT_TYPE_ACCESS,
    ignoreFields: [
      ...ignoreRegularReportFields,
      REPORT_FIELDS.CONTACT_HISTORY,
      REPORT_FIELDS.QUICK_SEARCH,
      REPORT_FIELDS.WAIT_COST,
      REPORT_FIELDS.DISPLAY_CLICK_LP_URL,
    ],
  },
  [REPORT_TYPE_CATEGORY]: {
    label: 'カテゴリ分析レポート',
    value: REPORT_TYPE_CATEGORY,
    ignoreFields: [
      ...ignoreDataExportFields,
      REPORT_FIELDS.SUMMARY_MODE,
      REPORT_FIELDS.DISPLAY_ROW_ZERO,
    ],
  },
  [REPORT_TYPE_DETAIL]: {
    label: '詳細分析レポート',
    value: REPORT_TYPE_DETAIL,
    ignoreFields: [
      ...ignoreDataExportFields,
      REPORT_FIELDS.SUMMARY_MODE,
      REPORT_FIELDS.DISPLAY_ROW_ZERO,
    ],
  },
  [REPORT_TYPE_PERIOD]: {
    label: '期間分析レポート',
    value: REPORT_TYPE_PERIOD,
    ignoreFields: [...ignoreDataExportFields],
  },
  [REPORT_TYPE_CONVERSION]: {
    label: 'コンバージョン属性レポート',
    value: REPORT_TYPE_CONVERSION,
    ignoreFields: [
      ...ignoreDataExportFields,
      REPORT_FIELDS.WAIT_COST,
      REPORT_FIELDS.SUMMARY_MODE,
      REPORT_FIELDS.DISPLAY_TOTAL,
      REPORT_FIELDS.DISPLAY_ROW_ZERO,
    ],
  },
  [REPORT_TYPE_CATEGORY_PERIOD]: {
    label: 'カテゴリ分析×期間分析レポート',
    value: REPORT_TYPE_CATEGORY_PERIOD,
    ignoreFields: [...ignoreDataExportFields],
  },
  [REPORT_TYPE_DETAIL_PERIOD]: {
    label: '詳細分析×期間分析レポート',
    value: REPORT_TYPE_DETAIL_PERIOD,
    ignoreFields: [...ignoreDataExportFields],
  },
};

export const REPORT_CHANNELS = [
  {
    label: '広告のみ',
    value: TAB_AD,
  },
  {
    label: '全トラフィック',
    value: TAB_ALL,
  },
];

export const HEADER_USER = [
  {
    isFreeze: true,
    field: 'rowId',
    name: '',
    sort: 'none',
    width: '45px',
    type: 'checkbox',
  },
  {
    isFreeze: true,
    field: 'user_id',
    name: 'ユーザーID',
    width: 'max-content',
    minWidth: '150px',
  },
  {
    field: 'company_name',
    name: '会社名',
    width: '201px',
  },
  {
    field: 'charge_name',
    name: '名前',
    width: '121px',
  },
  {
    field: 'email',
    name: 'メールアドレス',
    width: 'max-content',
    minWidth: '231px',
  },
  {
    field: 'roles',
    name: '閲覧',
    children: [
      {
        field: 'view_all',
        name: '全トラフィック',
        width: '122px',
        variant: 'icon-check',
      },
      {
        field: 'view_ad',
        name: '広告',
        width: '57px',
        variant: 'icon-check',
      },
    ],
  },
  {
    field: USER_TYPE,
    name: 'ユーザー種別',
    width: '200px',
  },
];

// Mapping key filter between new (key) & old (value) system
export const FILTER_KEY_MAPPER = {
  amount_min: 'amount_from',
  amount_max: 'amount_to',
  ad_date_min: 'ad_date_from',
  ad_date_max: 'ad_date_to',
  [FILTERS.FILTER_KEY_CHANNELS]: 'channel_access_type',
  [FILTERS.FILTER_KEY_CV]: 'conversion_ids',
  [FILTERS.FILTER_KEY_MEMBER_NAME_EXCLUDE]: 'member_name',
  [FILTERS.FILTER_KEY_OTHER1_EXCLUDE]: 'other1',
  [FILTERS.FILTER_KEY_OTHER2_EXCLUDE]: 'other2',
  [FILTERS.FILTER_KEY_OTHER3_EXCLUDE]: 'other3',
  [FILTERS.FILTER_KEY_OTHER4_EXCLUDE]: 'other4',
  [FILTERS.FILTER_KEY_OTHER5_EXCLUDE]: 'other5',
  [FILTERS.FILTER_KEY_AD_ID_EXCLUDE]: 'ad_id',
  [FILTERS.FILTER_KEY_AD_NAME_EXCLUDE]: 'ad_name',
  [FILTERS.FILTER_KEY_AD_GROUP1]: 'ad_group1_ids_selected',
  [FILTERS.FILTER_KEY_AD_GROUP1_EXCLUDE]: 'ad_group1_ids_selected',
  [FILTERS.FILTER_KEY_AD_GROUP2]: 'ad_group2_ids_selected',
  [FILTERS.FILTER_KEY_AD_GROUP2_EXCLUDE]: 'ad_group2_ids_selected',
  [FILTERS.FILTER_KEY_MEDIA]: 'ad_media_ids_selected',
  [FILTERS.FILTER_KEY_MEDIA_EXCLUDE]: 'ad_media_ids_selected',
  [FILTERS.FILTER_KEY_LANDING_PAGE_URL]: 'others_request_uri',
  [FILTERS.FILTER_KEY_PAGE_ID]: 'om_page_id',
  [FILTERS.FILTER_KEY_PAGE_TITLE]: 'om_page_title',
  [FILTERS.FILTER_KEY_CONTENT_CATEGORY]: 'om_page_category_ids_selected',
  [FILTERS.FILTER_KEY_CONTACT_HISTORY_AD]: 'target_ad',
  [FILTERS.FILTER_KEY_CONTACT_HISTORY_SEARCH]: 'search_target_ad',
  [FILTERS.FILTER_KEY_CONTACT_HISTORY_PAGE]: 'om_target_ad',
};

// Mapping operator value between old & new system
export const FILTER_OPERATOR_MAPPER = {
  [FILTERS.FILTER_OPERATOR_INCLUDE]: 0,
  [FILTERS.FILTER_OPERATOR_EXCLUDE]: 2,
  [FILTERS.FILTER_OPERATOR_EXACT]: 1,
  [FILTERS.FILTER_OPERATOR_FRONT]: 3,
};
// Mapping channel value between old & new system
export const FILTER_CHANNEL_MAPPER = {
  [CHANNEL_TYPE_ID.CLICK]: 'CLICK',
  [CHANNEL_TYPE_ID.SEARCH]: 'SEARCH',
  [CHANNEL_TYPE_ID.REFERRAL]: 'REFERRAL',
  [CHANNEL_TYPE_ID.DIRECT]: 'DIRECT',
  [CHANNEL_TYPE_ID.SITE_CONTENT]: 'OWNED_MEDIA',
  [CHANNEL_TYPE_ID.VIEW]: 'VIEW',
};

// Mapping contact history value between old & new system
export const FILTER_INDIRECT_MAPPER = {
  [FILTER_CONTACT_HISTORY_INDIRECT2]: 'ad_2',
  [FILTER_CONTACT_HISTORY_INDIRECT3]: 'ad_3',
  [FILTER_CONTACT_HISTORY_INDIRECT4]: 'ad_4',
  [FILTER_CONTACT_HISTORY_INDIRECT5]: 'ad_5',
  [FILTER_CONTACT_HISTORY_INDIRECT6]: 'ad_6',
  [FILTER_CONTACT_HISTORY_INDIRECT7]: 'ad_7',
  [FILTER_CONTACT_HISTORY_INDIRECT8]: 'ad_8',
  [FILTER_CONTACT_HISTORY_INDIRECT9]: 'ad_9',
  [FILTER_CONTACT_HISTORY_INDIRECT10]: 'ad_10',
};

export const FILTER_CONTACT_HISTORY_MAPPER = {
  [FILTER_CONTACT_HISTORY_DIRECT]: 'ad_1',
  ...FILTER_INDIRECT_MAPPER,
  [FILTER_CONTACT_HISTORY_FIRST]: 'ad_11',
};

// key (Old system), value (new system)
export const DISPLAYITEM_KEY_MAPPER = {
  // dimension
  channel_access_type: ['channel_access_type', 'contact_channel'],
  group0_name: ['category', 'contact_category'],
  group1_name: ['ad_group1', 'contact_ad_group1'],
  group2_name: ['ad_group2', 'contact_ad_group2'],
  ad_start_date: ['ad_date'],
  ad_end_date: ['ad_date'],
  daily: ['date'],
  ad_id: ['ad_id', 'contact_ad_id'],
  keyword: ['ad_name', 'contact_ad_name'],
  ad_name: ['ad_name', 'contact_ad_name'],
  terminal_type_modified: ['terminal_type'],
  page_category_name: ['content_category', 'contact_content_category'],
  conversion_title: ['cv_name'],
  contact_cnt: ['cnt_contact'],
  contact_count: ['cnt_contact'],
  normalized_request_uri: ['landing_page_url', 'contact_landing_page_url'],
  normalized_request_domain: [
    'landing_page_domain',
    'contact_landing_page_domain',
  ],

  // metric
  per_pv: ['per_page_view'],
  avg_contact_count: ['contact_avg'],
  avg_latency_time: ['latency_time_avg'],
  avg_total_stay_time: ['total_stay_time_avg'],
  latency_time_str: ['cv_contact_latency_time_avg'],
  latency_time: ['cv_contact_latency_time_avg'],
  latency_time_group: ['cv_contact_latency_time_avg'],
  direct: ['contact_direct'],
  indirect_2: ['contact_indirect2', 'cnt_indirect_2'],
  indirect_3: ['contact_indirect3', 'cnt_indirect_3'],
  indirect_4: ['contact_indirect4', 'cnt_indirect_4'],
  indirect_5: ['contact_indirect5', 'cnt_indirect_5'],
  indirect_6: ['contact_indirect6', 'cnt_indirect_other'],
  indirect_7: ['contact_indirect7', 'cnt_indirect_other'],
  indirect_8: ['contact_indirect8', 'cnt_indirect_other'],
  indirect_9: ['contact_indirect9', 'cnt_indirect_other'],
  indirect_10: ['contact_indirect10', 'cnt_indirect_other'],
  first_contract: ['contact_first', 'cnt_first'],
  cvr: ['cvr_total'],
  first_cnt: ['cnt_first', 'contact_first'],
  direct_cnt: ['cv_total', 'cnt_cv_flow'],
  indirect_total_cnt: ['indirect_total'],
  indirect2_cnt: ['cnt_indirect_2', 'contact_indirect2'],
  indirect3_cnt: ['cnt_indirect_3', 'contact_indirect3'],
  indirect4_cnt: ['cnt_indirect_4', 'contact_indirect4'],
  indirect5_cnt: ['cnt_indirect_5', 'contact_indirect5'],
  indirect_other_cnt: [
    'cnt_indirect_other',
    'contact_indirect6',
    'contact_indirect7',
    'contact_indirect8',
    'contact_indirect9',
    'contact_indirect10',
  ],
};

export const MESSAGE_DISABLED_SYSTEM_SYC = (
  <div>
    現在、データを準備中です。
    <br />
    本機能はお申し込み完了後から約3～5営業日ほどでご利用いただけます。
    <br />
    準備完了まで今しばらくお待ちください。
  </div>
);
